import React from 'react';
import {Accordion, Collapse} from 'flowbite';
import {Flow} from "three/examples/jsm/modifiers/CurveModifier";
import LandingHeader from "./LandingHeader";
import LandingHero from "./LandingHero";
import LandingContent from "./LandingContent";
import LandingFeatures from "./LandingFeatures";

const TexturingMainLanding = () => {
    return (
        <div className="text-left" style={{fontFamily: "Avenir"}}>

        <LandingHeader/>
            <LandingHero/>
            <LandingContent/>
            <LandingFeatures/>
        </div>
    );
};

export default TexturingMainLanding;